import { render } from "./PaintBrushStroke.vue?vue&type=template&id=12eaf01a"
import script from "./PaintBrushStroke.vue?vue&type=script&lang=js"
export * from "./PaintBrushStroke.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__